import React from "react";

export default function Step({ n, t }) {
  return (
    <div className="flex items-center gap-3">
      <div className="h-9 w-9 rounded-full bg-blue-50 text-blue-700 flex items-center justify-center font-semibold">
        {n}
      </div>
      <span className="text-[14px] text-slate-700 whitespace-nowrap">{t}</span>
    </div>
  );
}
